module.exports = __webpack_public_path__ + "img/sport_SERIEA.2e0077f9.png";